export default class Authorization {
  static get ROLES() {
    return {
      GENERIC: 'BWL-eko.ALLOW',
      BWL: 'BWL-eko.BWL',
      OSTRAL: 'BWL-eko.OSTRAL-Koordinationsstelle',
      VNB: 'BWL-eko.VNB',
      GP: 'BWL-eko.GP',
      GP_SUPERUSER: 'BWL-eko.GP-SuperUser'
    }
  }
}
